export type FlashMessageType = "success" | "error" | "info" | "warning";

export interface FlashMessage {
  type: FlashMessageType;
  message: string;
}

export const FLASH_COOKIE_NAME = "flash_message";

/**
 * Predefined flash messages to prevent XSS attacks.
 * All messages must be defined here and referenced by key.
 */
export const FLASH_MESSAGES = {
  AUTH_REQUIRED: {
    message: "Please sign in to access this page.",
    type: "info" as FlashMessageType,
  },
  AUTH_SUCCESS: {
    message: "Successfully signed in!",
    type: "success" as FlashMessageType,
  },
  AUTH_SIGNOUT: {
    message: "Successfully signed out.",
    type: "success" as FlashMessageType,
  },
  ACCOUNT_DELETED: {
    message: "Your account has been successfully deleted.",
    type: "success" as FlashMessageType,
  },
  UNAUTHORIZED: {
    message: "You don't have permission to access this page.",
    type: "error" as FlashMessageType,
  },
  ACCOUNTING_DISABLED: {
    message: "Condominium management is disabled for this organization.",
    type: "info" as FlashMessageType,
  },
  SESSION_EXPIRED: {
    message: "Your session has expired. Please sign in again.",
    type: "warning" as FlashMessageType,
  },
  ALREADY_AUTHENTICATED: {
    message: "You are already signed in.",
    type: "info" as FlashMessageType,
  },
} as const;

export type FlashMessageKey = keyof typeof FLASH_MESSAGES;
